import { render, staticRenderFns } from "./Sessions.vue?vue&type=template&id=ef742e04&scoped=true&"
import script from "./Sessions.vue?vue&type=script&lang=ts&"
export * from "./Sessions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef742e04",
  null
  
)

export default component.exports